import React, {useEffect} from "react";
import {RouterProvider} from "react-router-dom";
import router from "./router/router";
import {useTranslation} from "react-i18next";
import {setClickedRowKey, setIsScreenWide} from "./Header/store/headerSlice";
import {useAppDispatch} from "@features/store/store";
import {GetLanguages} from "@pages/LanguageTranslations/Languages/store/thunk";
import toast from "react-hot-toast";



function App() {
    const {i18n} = useTranslation();
    const savedLanguage = localStorage.getItem("languages") || "en";
    const dispatch = useAppDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(GetLanguages()).unwrap()
            } catch (err) {
                toast.error(t(`messages.${err}`));
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        i18n.changeLanguage(savedLanguage);
    }, [i18n]);

    useEffect(() => {
        const handleResize = () => {
            const isWide = window.innerWidth > 575;
            dispatch(setIsScreenWide(isWide));
            if (isWide) {
                dispatch(setClickedRowKey(null));
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [dispatch]);


    return <RouterProvider router={router}/>;
}

export default App;
